




































































































































































































































































import { defineComponent, PropType } from '~/utils/nuxt3-migration'
/* eslint-disable no-console,vue/no-side-effects-in-computed-properties,no-lonely-if */

import { mapGetters, mapMutations, mapState } from 'vuex'
import { PAGE_NS } from '~/store/modules/shared/page/state'
import { KeyCode } from '~/constants/keyboard'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import CCarouselThumb from '~/components/shared/configurable/image/carousel/CCarouselThumb.vue'
import CCarouselLoadingPlaceholder from '~/components/shared/configurable/image/carousel/CCarouselLoadingPlaceholder.vue'
import CCarouselYoutubeThumb from '~/components/shared/configurable/image/carousel/CCarouselYoutubeThumb.vue'
import CDragScroll from '~/components/shared/configurable/CDragScroll.vue'
import CBadge360 from '~/components/shared/configurable/badge/CBadge360.vue'
import CSwipeMixin from '~/components/shared/configurable/mixin/CSwipeMixin.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { SET_YOUTUBE_VISIBLE } from '~/store/modules/shared/classifieds/view/mutation-types'
import { ShortVideo } from '~/models/short-video'
import { ciPlay } from '~/icons/source/regular/play'
import { ciChevronLeft } from '~/icons/source/solid/chevron-left'
import { ciChevronRight } from '~/icons/source/solid/chevron-right'
import { ciCamera } from '~/icons/source/solid/camera'
import { ciYoutube } from '~/icons/source/solid/youtube'

export default defineComponent({
  components: {
    CCarouselLoadingPlaceholder,
    CCarouselThumb,
    CBadge360,
    CDragScroll,
    CCarouselYoutubeThumb
  },
  mixins: [CSwipeMixin],
  props: {
    bigPhotosOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    images: {
      type: Array,
      required: true
    },
    loadedThumbIndex: {
      type: Number,
      required: false,
      default: 0
    },
    youtube: {
      type: String,
      required: false,
      default() {
        return ''
      }
    },
    title: {
      type: String,
      required: false,
      default() {
        return ''
      }
    },
    autoSlide: { type: Boolean, default: false },
    placeholderImage: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: false,
      default: null
    },
    hideYoutubeThumb: {
      type: Boolean,
      required: false,
      default: false
    },
    noThumbs: {
      type: Boolean,
      required: false,
      default: false
    },
    sliderMode: {
      type: Boolean,
      required: false,
      default: false
    },
    counterPosition: {
      type: String as PropType<'top' | 'bottom'>,
      required: false,
      default: 'bottom'
    },
    imageClass: {
      type: [String, Object],
      default: null
    },
    shortVideos: {
      type: Array as PropType<ShortVideo[]>,
      default: () => []
    },
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      default: 'lg'
    }
  },
  data() {
    return {
      icons: {
        camera: ciCamera,
        chevronLeft: ciChevronLeft,
        chevronRight: ciChevronRight,
        ytIcon: ciYoutube,
        playButton: ciPlay
      },
      loadedPlaceholderImage: this.placeholderImage,
      activeImage: this.loadedThumbIndex,
      // Hold the timeout, so we can clear it when it is needed
      autoSlideTimeout: null,
      // auto slide interval in ms
      autoSlideInterval: 3000,
      // If the timer is stopped e.g. when hovering over the carousel
      stopSlider: false,
      // Hold the time left until changing to the next image
      timeLeft: 0,
      // Hold the interval so we can clear it when needed
      timerInterval: null,
      // Every 10ms decrease the timeLeft
      countdownInterval: 10,
      // the height of the loaded image (to solve some buggy behaviour)
      imgHeight: null,
      // youtube flag
      showVideo: false,
      paused: true,
      // image laod flag
      bigImageLoaded: false, // flag for the first load (to show the loading-placeholder)
      imgLoading: false, // flag to add the loading class
      showSpinner: false,
      thumbsLoaded: 0,
      imageObj: null,
      canClickThumbs: true,
      youtubeControlsInitialized: false as boolean,
      youtubeIframeApiReady: false as boolean,
      isYoutubeVideoInGalleryVisible: false
    }
  },
  computed: {
    ...mapState(PAGE_NS, {
      modalOpen: state => state.modalOpen
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      youtubeVisible: state => state.youtubeVisible
    }),
    isSwipable() {
      return !this.sliderMode
    },
    isServerRendered() {
      return process.server
    },
    youtubeEmbedLink() {
      if (this.youtube) {
        return 'https://www.youtube.com/embed/' + this.youtube
      }

      return null
    },
    countOf360() {
      return this.internalImages.filter(i => i.type === 'img360').length
    },
    // currentImage gets called whenever activeImage changes
    // and is the reason why we don't have to worry about the
    // big image getting updated
    currentImage() {
      this.timeLeft = this.autoSlideInterval

      const imgSrc = this.internalImages[this.activeImage].medium

      // bug solution
      if (this.imageObj) {
        const imageObj = this.imageObj
        imageObj.onload = () => {
          this.imgHeight = imageObj.height
        }
        try {
          imageObj.src = imgSrc
        } catch (e) {}
      }
      return imgSrc
    },
    showThumbs() {
      if (this.noThumbs && this.isMobile) {
        return false
      }

      if (this.youtube) {
        return true
      }

      return this.sliderMode || this.internalImages.length > 1
    },
    counterPositionClass() {
      if (this.counterPosition === 'top') {
        return 'tw-top-1'
      }
      return 'tw-bottom-0'
    },
    getVideo() {
      return this.internalImages?.find(i => i.type === 'video')
    },
    internalImages() {
      return [
        ...this.images.slice(0, 1),
        ...this.shortVideos.map(sv => ({
          ...sv,
          big: sv.thumbnail,
          medium: sv.thumbnail,
          thumb: sv.thumbnail,
          type: 'shortVideo'
        })),
        ...this.images.slice(1, this.images.length)
      ]
    }
  },
  watch: {
    async youtubeVisible(value) {
      if (value === true) {
        this.showVideo = true
        if (!this.youtubeControlsInitialized) {
          this.youtubeControlsInitialized = true
          await this.$nextTick()
          this.setupYoutubeControls()
        }
        // this.ytPlay()  uncomment this if you want autoplay
      } else if (this.internalImages.length) {
        this.showVideo = false
        this.ytPause()
        this.ytStop()
      }
    }
  },
  mounted() {
    this.imageObj = new Image()
    // add listeners for the thumbnails
    if (this.internalImages.length > 1) {
      // add listener for the arrow keys
      document.addEventListener('keyup', this.navigate)
    }

    if (this.$refs.imgelem && this.$refs.imgelem.complete) {
      this.bigImgLoad()
    }
  },
  beforeDestroy() {
    if (this.internalImages.length > 1) {
      // remove all possible listeners
      // remove listeners for the arrow keys
      document.removeEventListener('keyup', this.navigate)
    }

    if (window.ytPlayer) {
      window.onPlayerStateChange = null
    }
  },
  destroyed() {
    this.thumbsLoaded = 0
  },
  methods: {
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setYoutubeVisible: SET_YOUTUBE_VISIBLE
    }),
    setupYoutubeControls(
      iframeId: string = 'clsfd_video',
      videoId: string = this.youtube
    ) {
      window.onPlayerStateChange = event => {
        this.ytStateChange(event)
      }
      if (window.ytPlayer) {
        this.youtubeIframeApiReady = true
        // eslint-disable-next-line no-undef
        window.ytPlayer = new YT.Player(iframeId, {
          height: '431',
          videoId,
          events: {
            onStateChange: window.onPlayerStateChange
          }
        })
      } else {
        const tag = document.createElement('script')

        tag.src = 'https://www.youtube.com/iframe_api'
        tag.id = 'youtube-embed-script'
        const firstScriptTag = document.getElementsByTagName('script')[0]
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

        window.onYouTubeIframeAPIReady = () => {
          this.youtubeIframeApiReady = true
          // eslint-disable-next-line no-undef
          window.ytPlayer = new YT.Player(iframeId, {
            height: '431',
            videoId,
            events: {
              onStateChange: window.onPlayerStateChange
            }
          })
        }
      }
    },
    async removeImageIndex(i) {
      this.$emit('remove-image-index', i)
      await this.$nextTick()
      if (this.$refs.scroller) {
        this.$refs.scroller.calcDsWidth()
      }
    },
    // Go forward on the images array
    // or go at the first image if you can't go forward
    nextImage() {
      let active = this.activeImage + 1
      if (active >= this.internalImages.length) {
        active = 0
      }
      this.isYoutubeVideoInGalleryVisible = false
      this.activateImage(active)
    },
    // Go backwards on the images array
    // or go at the last image
    prevImage() {
      let active = this.activeImage - 1
      if (active < 0) {
        active = this.internalImages.length - 1
      }
      this.isYoutubeVideoInGalleryVisible = false
      this.activateImage(active)
    },
    activateImage(imageIndex) {
      if (imageIndex !== this.activeImage) {
        this.imgLoading = true
        const vm = this
        setTimeout(function() {
          if (vm.imgLoading) {
            vm.showSpinner = true
          }
        }, 1000)
      }
      this.activeImage = imageIndex

      const scroller = this.$refs.scroller
      if (scroller) {
        scroller.setActiveChildIndex(imageIndex)
      }
    },
    // Wait until 'interval' and go to the next image;
    startTimer(interval) {
      if (interval && interval > 0 && !this.stopSlider) {
        const self = this
        clearTimeout(this.autoSlideTimeout)
        this.autoSlideTimeout = setTimeout(function() {
          self.nextImage()
          self.startTimer(self.autoSlideInterval)
        }, interval)
      }
    },
    // Stop the timer when hovering over the carousel
    stopTimer() {
      clearTimeout(this.autoSlideTimeout)
      this.stopSlider = true
      clearInterval(this.timerInterval)
    },
    // Restart the timer(with 'timeLeft') when leaving from the carousel
    restartTimer() {
      if (this.autoSlide && !this.bigPhotosOpen && this.showThumbs) {
        this.stopSlider = false
        clearInterval(this.timerInterval)
        this.startCountdown()
        this.startTimer(this.timeLeft)
      }
    },
    // Start countdown from 'autoSlideInterval' to 0
    startCountdown() {
      const self = this
      this.timerInterval = setInterval(function() {
        self.timeLeft -= self.countdownInterval
        if (self.timeLeft <= 0) {
          self.timeLeft = self.autoSlideInterval
        }
      }, this.countdownInterval)
    },
    imgClicked(image: { type: string }) {
      if (!this.dragging) {
        const activeImage = this.internalImages[this.activeImage]
        if (activeImage?.type === 'img360') {
          this.thumbClicked('360')
        } else if (image.type === 'shortVideo') {
          this.$emit('show-short-video', this.activeImage)
        } else {
          this.$emit('big-photos-clicked', this.activeImage)
        }
      } else {
        this.dragging = false
      }
    },
    thumbClicked(indx) {
      if (indx === '360') {
        this.$emit('big-photos-clicked', indx)
        return
      }

      if (!this.canClickThumbs) {
        return
      }

      if (this.sliderMode && this.thumbIsShown(indx)) {
        const targetImage = this.internalImages[indx]
        if (targetImage?.type === 'img360') {
          this.$emit('big-photos-clicked', '360')
        } else if (targetImage?.type === 'shortVideo') {
          this.$emit('show-short-video', indx)
        } else {
          this.$emit('big-photos-clicked', indx)
        }
      }

      this.activateImage(indx)

      if (this.showVideo) {
        this.setYoutubeVisible(false)
      }
    },
    thumbIsShown(index) {
      const scroller = this.$refs.scroller
      if (scroller) {
        return scroller.childIsVisible(index)
      }
      return true
    },
    ytStateChange(event) {
      if (event.data === 1) {
        this.paused = false
      } else if (event.data === 2 || event.data === 0) {
        this.paused = true
      }
    },
    async ytClicked() {
      if (!this.youtubeControlsInitialized) {
        this.youtubeControlsInitialized = true
        await this.$nextTick()
        this.setupYoutubeControls()
      }

      if (!this.showVideo) {
        this.setYoutubeVisible(true)
        this.ytPlay()
      } else {
        if (this.paused) {
          this.ytPlay()
        } else {
          this.ytPause()
        }
      }
    },
    ytPlay(videoId: string = 'clsfd_video') {
      if (window.ytPlayer) {
        window.ytPlayer.playVideo()
      } else {
        document
          .getElementById(videoId)
          .contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            '*'
          )
        this.paused = false
      }
    },
    ytPause(videoId: string = 'clsfd_video') {
      if (window.ytPlayer) {
        window.ytPlayer.pauseVideo()
      } else {
        document
          .getElementById(videoId)
          .contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          )

        this.paused = true
      }
    },
    ytStop(videoId: string = 'clsfd_video') {
      if (window.ytPlayer) {
        window.ytPlayer.stopVideo()
      } else {
        document
          .getElementById(videoId)
          .contentWindow.postMessage(
            '{"event":"command","func":"stopVideo","args":""}',
            '*'
          )
      }
    },
    bigImgLoad() {
      this.bigImageLoaded = true
      this.imgLoading = false
      this.showSpinner = false
    },
    onSwipeRight() {
      this.prevImage()
    },
    onSwipeLeft() {
      this.nextImage()
    },
    navigate(e) {
      if (!this.bigPhotosOpen && !this.modalOpen) {
        const code = e.keyCode
        if (code === KeyCode.LEFT) {
          this.prevImage()
        }
        if (code === KeyCode.RIGHT) {
          this.nextImage()
        }
      }
    },
    increaseThumbsLoaded() {
      this.thumbsLoaded++
      if (
        this.thumbsLoaded === this.internalImages.length &&
        this.canClickThumbs
      ) {
        // we loaded the active thumb
        this.$nextTick(() => {
          if (this.sliderMode) {
            if (!this.thumbIsShown(this.activeImage)) {
              this.activateImage(this.activeImage)
            }
          } else {
            this.thumbClicked(this.activeImage)
          }
        })
      }
    },
    handleLoadVideoInGallery() {
      this.youtubeIframeApiReady = true
      this.isYoutubeVideoInGalleryVisible = true
      this.setupYoutubeControls('clsfd_video_in_gallery', this.getVideo.id)
    }
  }
})
